import { render, staticRenderFns } from "./ShelfDetailsModal.vue?vue&type=template&id=617df2e2&scoped=true&"
import script from "./ShelfDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ShelfDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ShelfDetailsModal.vue?vue&type=style&index=0&id=617df2e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617df2e2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VChip,VCol,VDialog,VIcon,VRow,VSwitch,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('617df2e2')) {
      api.createRecord('617df2e2', component.options)
    } else {
      api.reload('617df2e2', component.options)
    }
    module.hot.accept("./ShelfDetailsModal.vue?vue&type=template&id=617df2e2&scoped=true&", function () {
      api.rerender('617df2e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Vision/model/ShelfDetailsModal.vue"
export default component.exports